import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b17e7c24&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17e7c24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b17e7c24')) {
      api.createRecord('b17e7c24', component.options)
    } else {
      api.reload('b17e7c24', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b17e7c24&scoped=true", function () {
      api.rerender('b17e7c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/platformCard/index.vue"
export default component.exports